import createRootReducer from './root-reducer';
import { createConfigureStore } from '../../configure-store';

export default createConfigureStore({
  createRootReducer,
  createRootReducerPath: require.resolve('./root-reducer'),
});
